import { render, staticRenderFns } from "./auth-wechat.vue?vue&type=template&id=400cd0e4&scoped=true&lang=html&"
import script from "./auth-wechat.vue?vue&type=script&lang=js&"
export * from "./auth-wechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400cd0e4",
  null
  
)

export default component.exports